export default __webpack_public_path__ + "static/media/image4.d5826ae3.jpg";